@if (passwordRequirementsNotMet(control)) {
  <div class="password-requirements">
    <div class="font-regular-label-large">Passwortanforderungen:</div>
    <ul>
      <li
        [class]="{
          valid: !hasError('minLength'),
          invalid: hasError('minLength'),
        }">
        mindestens 8 Zeichen lang
      </li>
      <li
        [class]="{
          valid: !hasError('missingNumber'),
          invalid: hasError('missingNumber'),
        }">
        mindestens eine Zahl
      </li>
      <li
        [class]="{
          valid: !hasError('missingSpecialCharacter'),
          invalid: hasError('missingSpecialCharacter'),
        }">
        mindestens ein Sonderzeichen
      </li>
      <li
        [class]="{
          valid: !hasError('missingUpperCase'),
          invalid: hasError('missingUpperCase'),
        }">
        mindestens ein Großbuchstabe
      </li>
      <li
        [class]="{
          valid: !hasError('missingLowerCase'),
          invalid: hasError('missingLowerCase'),
        }">
        mindestens ein Kleinbuchstabe
      </li>
    </ul>
  </div>
} @else {
  <app-error-message [formField]="control"></app-error-message>
}
